import React from 'react';
import styles from './ThumbnailEvent.module.scss';

interface iThumbnailEvent {
  id: string;
  slug: string;
  image: string | null | undefined;
  name: string;
  year?: string | null | undefined;
  showroom: boolean;
  subtitle?: string | null | undefined;
  showroom_logo?: string | null | undefined;
  deadline_date?: string | null | undefined;
  date_of_the_end?: string | null | undefined;
}

export default function ThumbnailEvent({
  id,
  slug,
  image,
  name,
  year,
  subtitle,
  showroom = false,
  showroom_logo,
  deadline_date,
  date_of_the_end,
}: iThumbnailEvent): JSX.Element {
  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <div className={styles.ThumbnailEvent}>
      <a
        href={`/${BASE_PATH}/preview/events/${slug}/exhibitors`}
        className={styles.ThumbnailEvent__link}
      >
        {showroom && showroom_logo && (
          <div
            style={{
              marginTop: '15px',
              position: 'absolute',
              top: '0',
              left: '15px',
              zIndex: 1,
            }}
          >
            <img
              src={showroom_logo}
              alt=""
              width={50}
              height={280}
              className={styles.ThumbnailEvent__logo__img}
            />
          </div>
        )}
        <div className={styles.ThumbnailEvent__logo}>
          {image && (
            <img
              src={image}
              alt=""
              width={150}
              height={280}
              className={styles.ThumbnailEvent__logo__img}
            />
          )}
        </div>
        <div className={styles.ThumbnailEvent__content}>
          <div>
            <div className={styles.ThumbnailEvent__content__title}>
              {name} {year}
            </div>
            <p>{subtitle}</p>
          </div>
        </div>
      </a>
    </div>
  );
}
